import { Component, Input } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { EventDetailsModel } from '../../../../providers/event/event';

/**
 * Generated class for the EventMembersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-event-members',
  templateUrl: 'event-members.html',
})
export class EventMembersPage {
  @Input("event")
  event: EventDetailsModel;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EventMembersPage');
  }

}



// WEBPACK FOOTER //
// /src/pages/event/details/event-members/event-members.ts